import { render, staticRenderFns } from "./ConsentPDPA.vue?vue&type=template&id=5a767580"
import script from "./ConsentPDPA.vue?vue&type=script&lang=js"
export * from "./ConsentPDPA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports